<template>
  <div class="pis-headlines">
    <span ref="marquee" class="data" />
  </div>
</template>

<script>
import { Marquee, loop } from 'dynamic-marquee'
import axios from 'axios'

export default {
  data: () => ({
    news: [],
    marquee: null,
    control: null,
  }),
  async mounted () {
    this.marquee = new Marquee(this.$refs.marquee, { rate: -200 })

    this.marquee.onAllItemsRemoved(async () => {
      await this.fetchNews()

      this.updateLoop()
    })
  },
  async created() {
    await this.fetchNews()

    this.control = loop(this.marquee, this.news.map(news => () => news.content))
  },
  methods: {
    updateLoop () {
      this.control.update(this.news.map(news => () => news.content))
    },
    async fetchNews () {
      const response = await axios.get(this.route('current-news'))

      this.news = response.data.data
    },
  },
}
</script>
